module.exports = __webpack_public_path__ + "img/ai-icon.ea8a2af3.png";